import React,{useContext,useState} from "react";
import {Menu, Button } from 'antd'
import { Link, withRouter } from "react-router-dom";
import {UserContext} from "../Contexts/UserContext";
import {
  AppstoreOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  SlidersOutlined ,
  ContainerOutlined,
  DollarCircleOutlined,
  CopyOutlined 
} from '@ant-design/icons';
const { SubMenu } = Menu;
function SideBar(props) {
  const {username,setUsername,isLoggedIn,setIsLoggedIn,setTimeout,setToken} = useContext(UserContext);
  const [collapsed,setCollapsed]=useState(true)
  const toggleCollapsed = () => {
      setCollapsed(prev=>(!prev))
  };
  console.log("Set",setIsLoggedIn)
  const logout=()=>{
    localStorage.clear()
    setIsLoggedIn(false)
    setUsername('')
    setToken('')
    setTimeout('0')
  }
  const userSection=()=>{
    const username=localStorage.getItem('AOD:username')
      console.log("check",username)
      return username===''?
      <div></div>:
      <div style={{padding:'100px 0px'}} >
      <div style={{padding:'20px 0px'}}>{username}</div>
      <Button onClick={()=>logout()}> Logout</Button>
      </div>

  }
  console.log("Collapsed",collapsed)
  return (
    <div className="sideBar" style={collapsed ?{width: 80}:{ width: 256 }}>
      
        
          <h2>
            Dynasty Dash
          </h2>

          <Button type="primary" onClick={()=>toggleCollapsed()} style={{ marginBottom: 16 }}>
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
        </Button>
        <Menu
         className="sideBar"
          // defaultSelectedKeys={['1']}
          // defaultOpenKeys={['sub1']}
          mode="inline"
          theme="dark"
          inlineCollapsed={collapsed}
        >
          <Menu.Item style={{marginTop:'30px',marginBottom:'10px'}} key="1" icon={<HomeOutlined style={{fontSize:'30px'}} />}>
            Home
          </Menu.Item>
          {/* <SubMenu style={{padding:'10px 0px'}} key="sub1" icon={<SlidersOutlined style={{fontSize:'30px'}}  />} title="Matrix Analysis">
          <Menu.Item key="2"><Link className={`nav-item  ${
                    props.location.pathname === "/MatrixAnalyzer" ? "active" : ""
                  }`} to="/MyLeagues">
              MyLeagues
            </Link></Menu.Item>
          </SubMenu> */}
          <SubMenu style={{padding:'10px 0px'}} key="sub2" icon={<SlidersOutlined style={{fontSize:'30px'}}  />} title="Matrix Analysis">
          
            <Menu.Item key="4"><Link className={`nav-item`} to="/Projections">
              Projections
            </Link> </Menu.Item>
            <Menu.Item key="5"><Link className={`nav-item`} to="/MyDash">
              My Dash
            </Link> </Menu.Item>
            <Menu.Item key="6"><Link className={`nav-item`} to="/MyRosters">
              My Rosters
            </Link> </Menu.Item>
            <Menu.Item key="7"><Link className={`nav-item`} to="/mflLeagues">
              MFL Leagues
            </Link> </Menu.Item>
            <Menu.Item key="8"><Link className={`nav-item`} to="/lineups">
              Set Lineup
            </Link> </Menu.Item>
            <Menu.Item key="9"><Link className={`nav-item`} to="/propbets">
              Prop Bets
            </Link> </Menu.Item>
            <Menu.Item key="10"><Link className={`nav-item`} to="/trade-center">
              Trade Center
            </Link> </Menu.Item>
            
          </SubMenu>
          <div>
      {userSection()}
      </div>
        </Menu>
    </div>
  );
}

export default withRouter(SideBar);